<h2 class="h3 bold">Grid Options</h2>
<div class="grid-x">
  <div class="cell small-6 text-left">
    <div class="checkbox margin-bottom">
      <input id="selectCol" class="show-for-sr" type="checkbox" [(ngModel)]="componentConfig.displaySelectColumn">
      <label for="selectCol" class="inline">
        Display Select Column
        <span class="checkbox-box" aria-hidden="true" styledCheckbox>
          <span class="checkbox-check" aria-hidden="true">&#x2714;</span>
        </span>
      </label>
    </div>
  </div>
  <div class="cell small-6 text-right">
    <div class="checkbox">
      <input id="selectAll" class="show-for-sr" type="checkbox" [(ngModel)]="componentConfig.allowSelectAll"
        [disabled]="!componentConfig?.displaySelectColumn">
        <label for="selectAll" class="inline">
          Allow Select All
          <span class="checkbox-box" aria-hidden="true" styledCheckbox>
            <span class="checkbox-check" aria-hidden="true">&#x2714;</span>
          </span>
        </label>
      </div>
    </div>
  </div>
  <form [formGroup]="form">
    <div class="grid-x">
      <div class="cell small-6 text-left">
        <div class="checkbox margin-bottom">
          <input id="resizeCol" class="show-for-sr" type="checkbox" formControlName="enableColResize">
          <label for="resizeCol" class="inline">
            Allow Column Resizing
            <span class="checkbox-box" aria-hidden="true" styledCheckbox>
              <span class="checkbox-check" aria-hidden="true">&#x2714;</span>
            </span>
          </label>
        </div>
      </div>
    </div>
    <div>
      <label for="selectType">Item Selection Type</label>
      <select class="full-width" id="selectType" formControlName="rowSelection">
        <option [value]="rowSelectionTypes.Single">{{rowSelectionTypes.Single}}</option>
        <option [value]="rowSelectionTypes.Multiple">{{rowSelectionTypes.Multiple}}</option>
      </select>
    </div>
    @if (form.controls.rowSelection.value === rowSelectionTypes.Multiple) {
      <div class="checkbox outline-container">
        <input id="multiSelect" class="show-for-sr" type="checkbox" formControlName="rowMultiSelectWithClick">
        <label for="multiSelect" class="inline">
          Mouse Selection
          <span class="checkbox-box" aria-hidden="true" styledCheckbox>
            <span class="checkbox-check" aria-hidden="true">&#x2714;</span>
          </span>
        </label>
      </div>
    }
  </form>